import { Store } from '@reduxjs/toolkit';
import { ReducersInjectorWithState, StoreType } from '@wajeez-web/stores/base';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { actions } from './slices';
import * as thunks from './thunks';
import { AuthState } from './types';
import authReducer from './slices';

export const AuthActions = {
  ...actions,
  ...thunks,
};

export let authStore: StoreType<{ auth: AuthState }>;

// export type StoreType = typeof store;
export type AuthDispatch = typeof authStore.dispatch;
export type AuthStoreState = ReturnType<typeof authStore.getState>;
export const useAuthDispatch = () => useDispatch<AuthDispatch>();
export const useAuthSelector: TypedUseSelectorHook<AuthStoreState> =
  useSelector;
export const getAuthState = (store: Store) =>
  store.getState().auth as AuthState;

export const injectAuthReducers: ReducersInjectorWithState<
  AuthStoreState
> = () => {
  return [
    {
      name: 'auth',
      reducer: authReducer,
    },
  ];
};
